// Sync data with models.py CURRENCY
const CURRENCY = [
  {
    'code': 'USD',
    'country': 'US Dollar',
  },
  {
    'code': 'AED',
    'country': 'United Arab Emirates Dirham',
  },
  {
    'code': 'AFN',
    'country': 'Afghan Afghani',
  },
  {
    'code': 'ALL',
    'country': 'Albanian Lek',
  },
  {
    'code': 'AMD',
    'country': 'Armenian Dram',
  },
  {
    'code': 'ANG',
    'country': 'Netherlands Antillean Guilder',
  },
  {
    'code': 'AOA',
    'country': 'Angolan Kwanza',
  },
  {
    'code': 'ARS',
    'country': 'Argentine Peso',
  },
  {
    'code': 'AUD',
    'country': 'Australian Dollar',
  },
  {
    'code': 'AWG',
    'country': 'Aruban Florin',
  },
  {
    'code': 'AZN',
    'country': 'Azerbaijani Manat',
  },
  {
    'code': 'BAM',
    'country': 'Bosnia-Herzegovina Convertible Mark',
  },
  {
    'code': 'BBD',
    'country': 'Barbadian Dollar',
  },
  {
    'code': 'BDT',
    'country': 'Bangladeshi Taka',
  },
  {
    'code': 'BGN',
    'country': 'Bulgarian Lev',
  },
  {
    'code': 'BIF',
    'country': 'Burundian Franc',
  },
  {
    'code': 'BMD',
    'country': 'Bermudan Dollar',
  },
  {
    'code': 'BND',
    'country': 'Brunei Dollar',
  },
  {
    'code': 'BOB',
    'country': 'Bolivian Boliviano',
  },
  {
    'code': 'BRL',
    'country': 'Brazilian Real',
  },
  {
    'code': 'BSD',
    'country': 'Bahamian Dollar',
  },
  {
    'code': 'BWP',
    'country': 'Botswanan Pula',
  },
  {
    'code': 'BZD',
    'country': 'Belize Dollar',
  },
  {
    'code': 'CAD',
    'country': 'Canadian Dollar',
  },
  {
    'code': 'CDF',
    'country': 'Congolese Franc',
  },
  {
    'code': 'CHF',
    'country': 'Swiss Franc',
  },
  {
    'code': 'CLP',
    'country': 'Chilean Peso',
  },
  {
    'code': 'CNY',
    'country': 'Chinese Yuan',
  },
  {
    'code': 'COP',
    'country': 'Colombian Peso',
  },
  {
    'code': 'CRC',
    'country': 'Costa Rican Colón',
  },
  {
    'code': 'CVE',
    'country': 'Cape Verdean Escudo',
  },
  {
    'code': 'CZK',
    'country': 'Czech Koruna',
  },
  {
    'code': 'DJF',
    'country': 'Djiboutian Franc',
  },
  {
    'code': 'DKK',
    'country': 'Danish Krone',
  },
  {
    'code': 'DOP',
    'country': 'Dominican Peso',
  },
  {
    'code': 'DZD',
    'country': 'Algerian Dinar',
  },
  {
    'code': 'EGP',
    'country': 'Egyptian Pound',
  },
  {
    'code': 'ETB',
    'country': 'Ethiopian Birr',
  },
  {
    'code': 'EUR',
    'country': 'Euro',
  },
  {
    'code': 'FJD',
    'country': 'Fijian Dollar',
  },
  {
    'code': 'FKP',
    'country': 'Falkland Islands Pound',
  },
  {
    'code': 'GBP',
    'country': 'British Pound',
  },
  {
    'code': 'GEL',
    'country': 'Georgian Lari',
  },
  {
    'code': 'GIP',
    'country': 'Gibraltar Pound',
  },
  {
    'code': 'GMD',
    'country': 'Gambian Dalasi',
  },
  {
    'code': 'GNF',
    'country': 'Guinean Franc',
  },
  {
    'code': 'GTQ',
    'country': 'Guatemalan Quetzal',
  },
  {
    'code': 'GYD',
    'country': 'Guyanaese Dollar',
  },
  {
    'code': 'HKD',
    'country': 'Hong Kong Dollar',
  },
  {
    'code': 'HNL',
    'country': 'Honduran Lempira',
  },
  {
    'code': 'HRK',
    'country': 'Croatian Kuna',
  },
  {
    'code': 'HTG',
    'country': 'Haitian Gourde',
  },
  {
    'code': 'HUF',
    'country': 'Hungarian Forint',
  },
  {
    'code': 'IDR',
    'country': 'Indonesian Rupiah',
  },
  {
    'code': 'ILS',
    'country': 'Israeli New Shekel',
  },
  {
    'code': 'INR',
    'country': 'Indian Rupee',
  },
  {
    'code': 'ISK',
    'country': 'Icelandic Króna',
  },
  {
    'code': 'JMD',
    'country': 'Jamaican Dollar',
  },
  {
    'code': 'JPY',
    'country': 'Japanese Yen',
  },
  {
    'code': 'KES',
    'country': 'Kenyan Shilling',
  },
  {
    'code': 'KGS',
    'country': 'Kyrgystani Som',
  },
  {
    'code': 'KHR',
    'country': 'Cambodian Riel',
  },
  {
    'code': 'KMF',
    'country': 'Comorian Franc',
  },
  {
    'code': 'KRW',
    'country': 'South Korean Won',
  },
  {
    'code': 'KYD',
    'country': 'Cayman Islands Dollar',
  },
  {
    'code': 'KZT',
    'country': 'Kazakhstani Tenge',
  },
  {
    'code': 'LAK',
    'country': 'Laotian Kip',
  },
  {
    'code': 'LBP',
    'country': 'Lebanese Pound',
  },
  {
    'code': 'LKR',
    'country': 'Sri Lankan Rupee',
  },
  {
    'code': 'LRD',
    'country': 'Liberian Dollar',
  },
  {
    'code': 'LSL',
    'country': 'Lesotho Loti',
  },
  {
    'code': 'MAD',
    'country': 'Moroccan Dirham',
  },
  {
    'code': 'MDL',
    'country': 'Moldovan Leu',
  },
  {
    'code': 'MGA',
    'country': 'Malagasy Ariary',
  },
  {
    'code': 'MKD',
    'country': 'Macedonian Denar',
  },
  {
    'code': 'MMK',
    'country': 'Myanmar Kyat',
  },
  {
    'code': 'MNT',
    'country': 'Mongolian Tugrik',
  },
  {
    'code': 'MOP',
    'country': 'Macanese Pataca',
  },
  {
    'code': 'MRO',
    'country': 'Mauritanian Ouguiya (1973–2017)',
  },
  {
    'code': 'MUR',
    'country': 'Mauritian Rupee',
  },
  {
    'code': 'MVR',
    'country': 'Maldivian Rufiyaa',
  },
  {
    'code': 'MWK',
    'country': 'Malawian Kwacha',
  },
  {
    'code': 'MXN',
    'country': 'Mexican Peso',
  },
  {
    'code': 'MYR',
    'country': 'Malaysian Ringgit',
  },
  {
    'code': 'MZN',
    'country': 'Mozambican Metical',
  },
  {
    'code': 'NAD',
    'country': 'Namibian Dollar',
  },
  {
    'code': 'NGN',
    'country': 'Nigerian Naira',
  },
  {
    'code': 'NIO',
    'country': 'Nicaraguan Córdoba',
  },
  {
    'code': 'NOK',
    'country': 'Norwegian Krone',
  },
  {
    'code': 'NPR',
    'country': 'Nepalese Rupee',
  },
  {
    'code': 'NZD',
    'country': 'New Zealand Dollar',
  },
  {
    'code': 'PAB',
    'country': 'Panamanian Balboa',
  },
  {
    'code': 'PEN',
    'country': 'Peruvian Sol',
  },
  {
    'code': 'PGK',
    'country': 'Papua New Guinean Kina',
  },
  {
    'code': 'PHP',
    'country': 'Philippine Piso',
  },
  {
    'code': 'PKR',
    'country': 'Pakistani Rupee',
  },
  {
    'code': 'PLN',
    'country': 'Polish Zloty',
  },
  {
    'code': 'PYG',
    'country': 'Paraguayan Guarani',
  },
  {
    'code': 'QAR',
    'country': 'Qatari Rial',
  },
  {
    'code': 'RON',
    'country': 'Romanian Leu',
  },
  {
    'code': 'RSD',
    'country': 'Serbian Dinar',
  },
  {
    'code': 'RUB',
    'country': 'Russian Ruble',
  },
  {
    'code': 'RWF',
    'country': 'Rwandan Franc',
  },
  {
    'code': 'SAR',
    'country': 'Saudi Riyal',
  },
  {
    'code': 'SBD',
    'country': 'Solomon Islands Dollar',
  },
  {
    'code': 'SCR',
    'country': 'Seychellois Rupee',
  },
  {
    'code': 'SEK',
    'country': 'Swedish Krona',
  },
  {
    'code': 'SGD',
    'country': 'Singapore Dollar',
  },
  {
    'code': 'SHP',
    'country': 'St. Helena Pound',
  },
  {
    'code': 'SLL',
    'country': 'Sierra Leonean Leone',
  },
  {
    'code': 'SOS',
    'country': 'Somali Shilling',
  },
  {
    'code': 'SRD',
    'country': 'Surinamese Dollar',
  },
  {
    'code': 'SZL',
    'country': 'Swazi Lilangeni',
  },
  {
    'code': 'THB',
    'country': 'Thai Baht',
  },
  {
    'code': 'TJS',
    'country': 'Tajikistani Somoni',
  },
  {
    'code': 'TOP',
    'country': 'Tongan Paʻanga',
  },
  {
    'code': 'TRY',
    'country': 'Turkish Lira',
  },
  {
    'code': 'TTD',
    'country': 'Trinidad & Tobago Dollar',
  },
  {
    'code': 'TWD',
    'country': 'New Taiwan Dollar',
  },
  {
    'code': 'TZS',
    'country': 'Tanzanian Shilling',
  },
  {
    'code': 'UAH',
    'country': 'Ukrainian Hryvnia',
  },
  {
    'code': 'UGX',
    'country': 'Ugandan Shilling',
  },
  {
    'code': 'UYU',
    'country': 'Uruguayan Peso',
  },
  {
    'code': 'UZS',
    'country': 'Uzbekistani Som',
  },
  {
    'code': 'VND',
    'country': 'Vietnamese Dong',
  },
  {
    'code': 'VUV',
    'country': 'Vanuatu Vatu',
  },
  {
    'code': 'WST',
    'country': 'Samoan Tala',
  },
  {
    'code': 'XAF',
    'country': 'Central African CFA Franc',
  },
  {
    'code': 'XCD',
    'country': 'East Caribbean Dollar',
  },
  {
    'code': 'XOF',
    'country': 'West African CFA Franc',
  },
  {
    'code': 'XPF',
    'country': 'CFP Franc',
  },
  {
    'code': 'YER',
    'country': 'Yemeni Rial',
  },
  {
    'code': 'ZAR',
    'country': 'South African Rand',
  },
  {
    'code': 'ZMW',
    'country': 'Zambian Kwacha',
  },
];

export default CURRENCY;